export const GET_INVOICES = `
  query GetInvoices($where: invoices_bool_exp = {}, $limit: Int, $offset: Int, $order_by: [invoices_order_by!] = [{ created_at: desc }]) {
    invoices_aggregate(where: $where) {
      aggregate { count }
    }
    invoices(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
      id
      company_id
      firm_id
      firm_short_name
      firm_established
      contract_id
      job_id
      pricing_process_id
      invoice_name
      split_invoice
      custom_date_range
      date_range_start
      date_range_end
      invoice_code_ids
      payment_schedules
      total_unit_price
      invoice_code_id
      change_pricing_method
      new_pricing_type
      new_start_date
      created_at
      company {
        id
        name
      }
      contract {
        id
        contract_subject_id
        scope_of_work_id
        pricing_method_id
        work_status_id
        contract_signing_date
        invoice_issue_date
        auto_renewal
        renewal_period
        first_price_increase_period
        inflation_clause
        work_start_date
        work_started_without_contract
        protocol_start_date
        protocol_end_date
        comment
        contract_description
        contract_pdf_key
        protocol_pdf_key
        contract_pdf_size
        protocol_pdf_size
        company_id
        firm_id
        firm_short_name
        created_at
        updated_at
        contract_subject {
          id
          name
          is_project_based
        }
        scope_of_work {
          id
          name
        }
        pricing_method {
          id
          name
        }
        work_status {
          id
          name
        }
        company {
          id
          name
        }
        firm {
          id
          firm_name
          firm_short_name
        }
        renewals(order_by: { renewal_end_date: desc }) {
          id
          renewal_start_date
          renewal_end_date
        }
      }
      job {
        id
        job_title
        job_status
        job_type
        job_type_id
        job_type_rel { id name is_project_based }
        project_number
        description_of_job
        updated_at
        # GECMIS TABLOSU BU ALANLARDAN CIZILIYOR.
        #
        # Onceden yalnizca detail_data cekiliyordu: "Is Durumu
        # Goruntule" penceresindeki Gecmis tablosunda Tarih, Islem Yapan
        # ve Islem Tipi sutunlari bos ("-") goruluyordu. Durum ve Not
        # detail_data icinde oldugu icin yalnizca onlar doluydu.
        # Is Yonetimi ekraninda ayni pencere calisiyordu cunku GET_JOBS
        # bu alanlari zaten seciyor.
        job_details(order_by: { created_at: desc }) {
          id
          job_detail_type
          detail_data
          created_at
          user {
            first_name
            last_name
          }
        }
      }
      pricing_process {
        id
        name
      }
    }
  }
`;

export const GET_INVOICE_BY_ID = `
  query GetInvoiceById($id: Int!) {
    invoices_by_pk(id: $id) {
      id
      company_id
      firm_id
      firm_short_name
      firm_established
      contract_id
      job_id
      pricing_process_id
      invoice_name
      split_invoice
      custom_date_range
      date_range_start
      date_range_end
      invoice_code_ids
      payment_schedules
      total_unit_price
      invoice_code_id
      change_pricing_method
      new_pricing_type
      new_start_date
      created_at
      company {
        id
        name
      }
      contract {
        id
        contract_subject_id
        scope_of_work_id
        pricing_method_id
        work_status_id
        contract_signing_date
        auto_renewal
        renewal_period
        inflation_clause
        work_start_date
        work_started_without_contract
        protocol_start_date
        protocol_end_date
        comment
        contract_description
        contract_pdf_key
        protocol_pdf_key
        contract_pdf_size
        protocol_pdf_size
        company_id
        firm_id
        firm_short_name
        created_at
        updated_at
        contract_subject {
          id
          name
          is_project_based
        }
        scope_of_work {
          id
          name
        }
        pricing_method {
          id
          name
        }
        work_status {
          id
          name
        }
        company {
          id
          name
        }
        firm {
          id
          firm_name
          firm_short_name
        }
        renewals(order_by: { renewal_end_date: desc }) {
          id
          renewal_start_date
          renewal_end_date
        }
      }
      job {
        id
        job_title
        job_status
        job_type
        job_type_id
        job_type_rel { id name is_project_based }
        project_number
        description_of_job
        updated_at
        # GECMIS TABLOSU BU ALANLARDAN CIZILIYOR.
        #
        # Onceden yalnizca detail_data cekiliyordu: "Is Durumu
        # Goruntule" penceresindeki Gecmis tablosunda Tarih, Islem Yapan
        # ve Islem Tipi sutunlari bos ("-") goruluyordu. Durum ve Not
        # detail_data icinde oldugu icin yalnizca onlar doluydu.
        # Is Yonetimi ekraninda ayni pencere calisiyordu cunku GET_JOBS
        # bu alanlari zaten seciyor.
        job_details(order_by: { created_at: desc }) {
          id
          job_detail_type
          detail_data
          created_at
          user {
            first_name
            last_name
          }
        }
      }
      pricing_process {
        id
        name
      }
    }
  }
`;